/**
 * RFC 5322 email address validation helper.
 * Ported from login-service/src/shared/helpers/rfc5322EmailHelper.ts.
 */

export default class Rfc5322EmailHelper {
    _extractLocalPart(s) {
        const sepIndex = s.lastIndexOf("@");
        return sepIndex > -1 ? s.substring(0, sepIndex) : null;
    }

    _extractDomain(s) {
        const sepIndex = s.lastIndexOf("@");
        return sepIndex > -1 ? s.substring(sepIndex + 1) : null;
    }

    _toASCII(domain) {
        if (/[/:?]/.test(domain)) {
            return domain;
        }

        try {
            // The URL constructor performs IDN/punycode encoding natively in browsers
            return new URL("http://" + domain).hostname;
        } catch {
            return domain.toLowerCase();
        }
    }

    _validateLocalPart(s) {
        // https://regex101.com/r/72qfcR/1/ — assumes lowercase input
        const matched = s.match(/^(?:[a-z0-9!#$%&'*+\-/=?^_`{|}~]+|"(?:\\.|[^\\"])+")(?:\.(?:[a-z0-9!#$%&'*+\-/=?^_`{|}~]+|"(?:\\.|[^\\"])+"))*$/);
        return matched ? true : false;
    }

    _validateDomain(s) {
        // https://regex101.com/r/yC0b0V/2/ — assumes lowercase input
        const matched = s.match(/^(?:[0-9a-z](?:[-0-9a-z]{0,61}[0-9a-z])?|(?:[0-9a-z](?:[-0-9a-z]{0,61}[0-9a-z])?\.)+[a-z][a-z0-9_-]{0,61}[a-z0-9]|\[(?:\d{1,3}\.){3}\d{1,3}])$/);
        return matched ? true : false;
    }

    _isValidEmail(s) {
        if (s.trim().length === 0) {
            return false;
        }

        let local = this._extractLocalPart(s);
        let domain = this._extractDomain(s);

        if (local === null || local.length === 0 || local.length > 64 || domain === null || domain.length === 0 || domain.length > 253) {
            return false;
        }

        domain = this._toASCII(domain);

        // Remove comments; validate against lowercase text
        local = local.replace(/\(.*?\)/g, "").toLowerCase();
        domain = domain.replace(/\(.*?\)/g, "").toLowerCase();

        return this._validateLocalPart(local) && this._validateDomain(domain);
    }

    isValidFormat(s) {
        return this._isValidEmail(s);
    }

    extractLocalPart(s) {
        return this._extractLocalPart(s);
    }

    extractDomain(s) {
        return this._extractDomain(s);
    }
}
